import React, { FC } from "react";
import { SidebarLinkPathTypes, SidebarLinkTypes } from "../LinkTypes";
import { useLocale } from "../../../hooks/UseLocale";
import { useTranslation } from "react-i18next";
import { ComplexLinkBox, LinkWrapper } from "../Layout.styles";
import { useNavigate } from 'react-router-dom';
import { SxProps, Theme } from "@mui/material";

interface SimpleSidebarLinkProps {
  linkName?: SidebarLinkTypes;
  name?: string;
  isActive?: boolean;
  activePathname?: string;
}

interface SidebarLinkComponentProps extends SimpleSidebarLinkProps {
  icon?: React.ReactNode;
  path: SidebarLinkPathTypes | string;
  showText?: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
  collapsed?: boolean;
}

export const SimpleSidebarLink: FC<SidebarLinkComponentProps> = ({
  isActive,
  linkName,
  name,
  icon,
  path,
  activePathname,
  sx,
  showText = true,
  collapsed = false,
}) => {
  const { t } = useTranslation();
  const locale = useLocale();
  const navigate = useNavigate();

  const handleOnClick = () => navigate(`/${locale}${path ? "/" + path : ""}`);
  const active = isActive ?? activePathname === path;

  return (
    <LinkWrapper
      isActive={active}
      onClick={handleOnClick}
      sx={{
        // pl: 2,
        // pr: 2,
        // justifyContent: collapsed ? "center" : "flex-start",
        ...sx,
      }}
    >
      {icon ? (
        <ComplexLinkBox isActive={active} collapsed={collapsed}>
          {icon}
          {showText && !collapsed && (
            <div className="sidebar-link-text">
              {name ?? (linkName && t(linkName))}
            </div>
          )}
        </ComplexLinkBox>
      ) : (
        <div>{showText && (name ?? (linkName && t(linkName)))}</div>
      )}
    </LinkWrapper>
  );
};

export default SimpleSidebarLink;
